import { IonContent, IonGrid, IonItem, IonLabel } from "@ionic/react";

import { bookOutline } from "ionicons/icons";
import HeaderComponent from "../components/HeaderComponent";

const appPages = [
  {
    imgIcon: bookOutline,
    title: "TDS document",
    desc: "related to TDS information available here",
    pdfLocation: "./assets/brand/tds.pdf",
  },
  {
    imgIcon: bookOutline,
    title: "Fitment Diagram",
    desc: "more details on the Fitment information",
    pdfLocation: "./assets/brand/fitment.pdf",
  },
  {
    imgIcon: bookOutline,
    title: "Test report",
    desc: "detailed testing report of the battery pack",
    pdfLocation: "./assets/brand/testing.pdf",
  },
];

const Datasheets: React.FC<any> = () => {
  const openPDF = (pdfLocation: any) => {
    window.open(pdfLocation);
  };

  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Datasheets"} />
      <IonGrid fixed>
        {appPages.map((appPage, index) => {
          return (
            <IonItem key={index}>
              <img
                alt="document"
                src="./assets/brand/document.png"
                height={48}
                onClick={() => openPDF(appPage.pdfLocation)}
              />
              <IonLabel className="ion-padding ">
                <h2>{appPage.title}</h2>
                <p className="wrap">{appPage.desc}</p>
                <p className="customSmallerFont">
                  Click on document image to open it
                </p>
              </IonLabel>
            </IonItem>
          );
        })}
      </IonGrid>
    </IonContent>
  );
};

export default Datasheets;
